import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericResourceService } from './generic-resource.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [GenericResourceService]
})
export class GenericResourceModule { }
